import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../theme";


interface MemoryBookMinimisedPillProps {
  overdueCount: number;
  inDangerCount: number;
  onExpand: () => void;
}


const MemoryBookMinimisedPill = ({
  overdueCount,
  inDangerCount,
  onExpand,
}: MemoryBookMinimisedPillProps) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: { xs: 12, md: 50 },
        right: { xs: 12, md: 50 },
        zIndex: 100,
        cursor: "pointer",
      }}
      onClick={onExpand}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          borderRadius: 50,
          backgroundColor: colors.primary[900],
          border: `1px solid ${colors.primary[300]}30`,
          overflow: "hidden",
          transition: "box-shadow 0.2s ease",
          "&:hover": { boxShadow: "0 4px 16px rgba(0,0,0,0.2)" },
        }}
      >
        {/* Label */}
        <Box sx={{ px: 2.5, py: 1.5 }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "0.75rem",
              letterSpacing: "0.08em",
              color: colors.primary[700],
              textTransform: "uppercase",
              whiteSpace: "nowrap",
            }}
          >
            Memory Books
          </Typography>
        </Box>

        {/* Divider */}
        <Box sx={{ width: "1px", height: 40, backgroundColor: colors.primary[300] + "40" }} />

        {/* Overdue */}
        <Box sx={{ px: 2, py: 1.5, display: "flex", alignItems: "center", gap: 0.8 }}>
          <Box
            sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#E11D48" }}
          />
          <Typography sx={{ fontWeight: 700, fontSize: "0.85rem", color: "#E11D48" }}>
            {overdueCount}
          </Typography>
          <Typography sx={{ fontSize: "0.7rem", color: colors.primary[700] }}>
            overdue
          </Typography>
        </Box>

        {/* Divider */}
        <Box sx={{ width: "1px", height: 40, backgroundColor: colors.primary[300] + "40" }} />

        {/* In Danger */}
        <Box sx={{ px: 2, py: 1.5, display: "flex", alignItems: "center", gap: 0.8 }}>
          <Box
            sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#f59e0b" }}
          />
          <Typography sx={{ fontWeight: 700, fontSize: "0.85rem", color: "#f59e0b" }}>
            {inDangerCount}
          </Typography>
          <Typography sx={{ fontSize: "0.7rem", color: colors.primary[700] }}>
            in danger
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default MemoryBookMinimisedPill;